module.exports = __webpack_public_path__ + "img/button_chart_circle.fc288ba9.png";